<template>
  <section class="">
    <div class="level-item">
      <img class="logo-header" src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />
    </div>
    <div class="level-item">
      <p class="title is-2 title-custom">{{ meetingDetails.title }}</p>
    </div>
    <br />

    <v-card class="mx-auto transition-swing card-holder" :elevation="5" :loading="isLoading" v-if="meetingName">
      <div>
        <v-avatar class="ms-3 mt-2" color="indigo" size="70"> <v-icon dark> mdi-account-circle </v-icon> </v-avatar>
        <span class="ms-3 username">{{ attendee }}</span>
      </div>
      <v-card-text>
        <span>Meeting Schedule:</span>
        <v-row>
          <v-col>
            <v-icon class="mr-1"> mdi-timetable </v-icon>
            <span class="subheading mr-2">{{ meetingDetails.date }}</span>
          </v-col>
          <v-col>
            <v-icon class="mr-1"> mdi-clock </v-icon>
            <span class="subheading mr-2"> {{ meetingDetails.fromTime }}-{{ meetingDetails.toTime }}</span>
          </v-col>
          <!-- <v-col >
            <v-icon class="mr-1"> mdi-timer </v-icon>
            <span class="subheading mr-2"> {{ meetingDetails.duration }} min</span>
          </v-col> -->
        </v-row>
      </v-card-text>

      <v-divider class="mt-0 mb-0"></v-divider>
      <v-card-actions class="bg-light-gray">
        <v-row align="center" justify="space-around">
          <v-btn normal color="success" dark class="font-weight-bold" @click="joinNow"> Join Now </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
    <div v-if="!isLoading && !meetingName">
      <section class="container section page-header section is-main-section">
        <p class="title is-4" style="text-align: center">{{ errMessage }}</p>
      </section>
    </div>
  </section>
</template>

<script>
import constants from '@/utils/constants'
import moment from 'moment'
export default {
  components: {},
  name: 'joinTrainingMeeting',

  props: ['referenceID'],
  data: function () {
    return {
      isLoading: false,
      meetingName: null,
      meetingTime: '',
      duration: '',
      attendee: '',
      description: '',
      meetingURL: '',
      errMessage: '',
      moderator: [],
      meetingEndTime: '',
      meetingDetails: {
        title: '',
        date: '',
        fromTime: '',
        toTime: '',
        duration: ''
      }
    }
  },
  created: async function () {
    await this.getMeetingURL()
  },
  methods: {
    getMeetingURL: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/join?referenceID=${this.referenceID}`)
        if (data) {
          this.meetingDetails = {
            title: data.meetingName,
            date: moment(data.meetingTime).format('MMMM Do YYYY'),
            fromTime: moment(data.meetingTime).format('h:mm A'),
            toTime: moment(`${moment().format('YYYY-MM-DD')} ${data.meetingEndtime}`).format('h:mm A'),
            duration: data.duration
          }

          this.meetingName = data.meetingName
          this.duration = data.duration
          this.meetingTime = `${moment(data.meetingTime).format('MMMM Do YYYY')}, ${moment(data.meetingTime).format('h:mm A')} - ${moment(
            `${moment().format('YYYY-MM-DD')} ${data.meetingEndtime}`
          ).format('h:mm A')}`
          this.attendee = data.attendee
          this.meetingURL = data.meetingURL
          // this.description = data.description
          this.moderator = data.moderator
          console.log('this.meetingEndTime', this.meetingEndTime)
        }
        this.isLoading = false
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
        this.isLoading = false
        this.errMessage = errorMessage
        this.loadingComponent.close()
      }
    },
    joinNow: async function () {
      window.open(this.meetingURL)
      this.$router.push({ name: 'AllTrainings' })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
.logo-header {
  height: 100px;
  width: auto;
}

.card-holder {
  min-width: 400px;
  width: fit-content;
  border-radius: 20px;
}

.bg-light-gray {
  background: #eee;
}

.title-custom {
  font-size: 26px !important;
  font-weight: 600;
}

.username {
  font-size: 20px !important;
  font-weight: 500;
}
</style>
